const pages = [
  {
    name: "Home",
    route: "/",
    noNav: true,
  },
  {
    name: "About Heathen",
    route: "/about-heathen",
    getContent: () => import("./aboutHeathen.md").then((args) => args.default),
  },
  {
    name: "ExEgypt",
    route: "/exegypt",
    getContent: () => import("./exEgypt.md").then((args) => args.default),
  },
  {
    name: "Subreddit",
    route: "/subreddit",
    nested: true,
    getContent: () => import("./subreddit.md").then((args) => args.default),
  },
  {
    name: "Discord Server",
    route: "/discord",
    nested: true,
    getContent: () => import("./discordServer.md").then((args) => args.default),
  },
  {
    name: "Other Platforms",
    route: "/other-platforms",
    nested: true,
    getContent: () =>
      import("./otherPlatforms.md").then((args) => args.default),
  },
  {
    name: "Heathen's Journey",
    nameSec: "Finding Hope Amidst The Depth of Despair",
    route: "/heathens-journey",
    getContent: () =>
      import("./heathensJourney.md").then((args) => args.default),
  },
  {
    name: "Tributes",
    route: "/tributes",
    getContent: () => import("./tributes.md").then((args) => args.default),
  },
];

export default pages;
